<div class="position-relative h-100 card-wrapper d-flex justify-content-between">
    <img src="assets/images/virtusa-icons/test_case_icon.svg" alt="TC">
    <span class="m-auto content-text header-4 ellipsis-text" matTooltip="{{ data?.name }}">{{data?.name}}</span>
    <img class="download-icon" src="assets/images/virtusa-icons/download.svg" (click)="onDownload()" (keydown)="onDownload()" alt="download">
</div>
